module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("View Members")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100%"
    },
    slot: "content"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.detail.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.attrText.userName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": _vm.attrText.account
    }
  })], 1), _vm._v(" "), (_vm.detail.totalCount > 10) ? _c('div', {
    staticClass: "pagination"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.detail.totalCount,
      "page-size": 10,
      "current-page": _vm.detail.currentPage
    },
    on: {
      "update:currentPage": function($event) {
        _vm.detail.currentPage = $event
      },
      "current-change": _vm.handlePageChange
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs['right-panel'].onClose()
      }
    }
  }, [_c('translate', [_vm._v("Close")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2387765e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/workgroup-view-group.vue
// module id = 538
// module chunks = 4 5 6